(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-benefits-bundles"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-pdp-bundles-list]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const items = Array.from(root.querySelectorAll('[data-pdp-bundle-item]'));
    const size = Number(root.dataset.pageSize || 3);
    const pageTotal = Math.max(1, Math.ceil(items.length / size));
    let page = 0;
    const pageText = root.querySelector('[data-pdp-page]');
    const prev = root.querySelector('[data-pdp-prev]');
    const next = root.querySelector('[data-pdp-next]');
    const render = () => {
      items.forEach((item, index) => {
        item.hidden = Math.floor(index / size) !== page;
      });
      if (pageText) pageText.textContent = `${page + 1} / ${pageTotal}`;
      if (prev) prev.disabled = page === 0;
      if (next) next.disabled = page >= pageTotal - 1;
    };
    prev?.addEventListener('click', () => { if (page > 0) { page -= 1; render(); } });
    next?.addEventListener('click', () => { if (page < pageTotal - 1) { page += 1; render(); } });
    render();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-product-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      document.querySelectorAll('[data-pdp-bundle-root]').forEach((root) => {
        const list = root.querySelector('[data-pdp-bundle-items]');
        if (!list || list.dataset.initialized === 'true') return;
        list.dataset.initialized = 'true';
        const items = [...list.querySelectorAll('[data-pdp-bundle-item]')],
          size = Number(list.dataset.pageSize || 3),
          total = Math.max(1, Math.ceil(items.length / size));
        let page = 0;
        const text = root.querySelector('[data-pdp-bundle-page]'),
          prev = root.querySelector('[data-pdp-bundle-prev]'),
          next = root.querySelector('[data-pdp-bundle-next]');
        const render = () => {
          items.forEach((item, i) => (item.hidden = Math.floor(i / size) !== page));
          if (text) text.textContent = `${page + 1} / ${total}`;
          if (prev) prev.disabled = page === 0;
          if (next) next.disabled = page >= total - 1;
        };
        prev?.addEventListener('click', () => {
          if (page > 0) {
            page--;
            render();
          }
        });
        next?.addEventListener('click', () => {
          if (page < total - 1) {
            page++;
            render();
          }
        });
        render();
      });
    };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
